function SignatureIcon({ width = '21', height = '20', fill = '#615A5A' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1629 11.1196V9.56534L16.805 7.96346V11.8118C16.805 13.7749 11.3466 19.7054 8.74957 19.7054H0.383789V0H14.0881L12.3951 1.64212H2.02591V18.0633H8.07055C11.4829 18.0633 10.2365 13.137 10.2365 13.137C10.2365 13.137 15.1629 14.4917 15.1629 11.1196ZM13.3908 2.96567C13.1116 3.23662 13.0968 3.6767 13.3678 3.95669L17.2301 0.211012C17.0938 0.06979 16.9139 0 16.7341 0C16.5568 0 16.3786 0.0681479 16.239 0.202802L13.3908 2.96567ZM8.59459 11.2043C8.59459 11.1279 8.62497 11.0515 8.68244 10.9949L9.16194 10.5293L9.56672 10.9473L9.08805 11.4128C9.03139 11.4678 8.95832 11.4949 8.88525 11.4949C8.72432 11.4949 8.59459 11.3635 8.59459 11.2043ZM12.7244 5.61523L11.0872 7.20234C10.207 8.05542 9.75791 8.88222 9.34328 10.0358L10.0666 10.7822C11.2317 10.4036 12.0717 9.9808 12.9518 9.1269L14.589 7.53897L12.7244 5.61523ZM13.282 4.81429L17.4997 0.723767C18.4727 -0.220451 20.0885 0.487302 20.0885 1.8207C20.0885 2.21974 19.9334 2.61795 19.6238 2.91846L15.4052 7.00734L13.282 4.81429ZM7.77312 10.6737H4.48888V11.4959H7.77312V10.6737Z"
        fill={fill}
      />
    </svg>
  );
}

export default SignatureIcon;
